module.exports = __webpack_public_path__ + "fonts/seguisbi.3f0b6094.ttf";